// extracted by mini-css-extract-plugin
module.exports = {"top":"Layout_top__2Zj_T","topBottomGutter":"Layout_topBottomGutter__2pXs0"};